import { Users } from "lucide-react";
import { CardParticipante } from "@/modules/escala/components/CardParticipante";
import type { ParticipanteDetalhe } from "@/modules/escala/services/escalaService";

interface ListaParticipantesProps {
  participantes: ParticipanteDetalhe[];
  /** Ações de gestão: a página só passa as que valem para esta escala (ativa, e para "registrar resposta", ainda aberta). */
  onAlterarFuncao?: (participante: ParticipanteDetalhe) => void;
  onRemover?: (participante: ParticipanteDetalhe) => void;
  /** Oferecida só para participantes com resposta PENDENTE. */
  onRegistrarResposta?: (participante: ParticipanteDetalhe) => void;
}

/** Estado vazio dedicado (escala sem participantes ≠ lista de escalas vazia ≠ histórico vazio). */
export function ListaParticipantes({
  participantes,
  onAlterarFuncao,
  onRemover,
  onRegistrarResposta,
}: ListaParticipantesProps) {
  if (participantes.length === 0) {
    return (
      <div className="flex flex-col items-center gap-2 rounded-2xl border border-dashed border-border px-5 py-9 text-center">
        <span className="grid h-12 w-12 place-items-center rounded-full bg-surface-2 text-muted">
          <Users size={24} aria-hidden />
        </span>
        <p className="text-[15px] font-bold text-text">Ainda não há participantes</p>
        <p className="text-sm text-muted">Nesta escala ninguém foi escalado até agora.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2.5">
      {participantes.map((p) => (
        <CardParticipante
          key={p.id}
          participante={p}
          onAlterarFuncao={onAlterarFuncao ? () => onAlterarFuncao(p) : undefined}
          onRemover={onRemover ? () => onRemover(p) : undefined}
          onRegistrarResposta={onRegistrarResposta && p.resposta === "PENDENTE" ? () => onRegistrarResposta(p) : undefined}
        />
      ))}
    </div>
  );
}
